import {
    LAST_24_HOURS_VALUE,
    LAST_WEEK_VALUE,
    LAST_MONTH_VALUE,
    LAST_THREE_MONTHS_VALUE,
    LAST_SIX_MONTHS_VALUE,
    ANOTHER_PERIOD_VALUE
} from './constants';

export const periods = [
    { label: '1', value: LAST_24_HOURS_VALUE },
    { label: '7', value: LAST_WEEK_VALUE },
    { label: '30', value: LAST_MONTH_VALUE },
    { label: '90', value: LAST_THREE_MONTHS_VALUE },
    { label: '180', value: LAST_SIX_MONTHS_VALUE },
    { label: 'anotherPeriod', value: ANOTHER_PERIOD_VALUE }
];
